import { IMatchUser, MatchStatus } from '@mentessa/types';

export function isActionRequired(matchUser: IMatchUser) {
  return matchUser.match?.status === MatchStatus.Pending && matchUser.accepted == null ? 1 : 0;
}

export function compareMatches(l: IMatchUser, r: IMatchUser) {
  return isActionRequired(r) - isActionRequired(l);
}
